import styled from "styled-components";

export const Section = styled.section`
 padding-top: 100px;
  width: 90%;
  display: flex;
  margin: auto;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin-bottom: 100px;

  @media screen and (max-width: 500px) {
    width: 95%;
  }
`


export const AboutStyled = styled.div`
  margin-top: 120px;
  padding: 25px;
  width: 500px;
  border: 1px solid ${props => props.theme.siteColor};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 500px) {
    margin-top: 30px;
    padding: 15px;
  }

  h2 {
  margin-bottom: 30px;
}

h3 {
  margin-bottom: 15px;
}
span {
  color: ${props => props.theme.siteColor};
}
p {
  margin-top: 10px;
}
`